
       const __ReactNativeSvgLoader = require('react-native-svg-transformer-fix-expo').default({
  "replaceAttrValues": {
    "#000": "{props.color}"
  }
});
        import { Flex, Pressable, Text } from '@ui/atoms';
import CustomPropTypes from '@utils/CustomPropTypes';

  const LikeIcon = __ReactNativeSvgLoader(import('@src/assets/icons/like.svg'));
  ;

  const LikeOutlinedIcon = __ReactNativeSvgLoader(import('@src/assets/icons/likeOutlined.svg'));
  ;

  const HeartIcon = __ReactNativeSvgLoader(import('@src/assets/icons/heart_filled_v2.svg'));
  ;

  const HeartOutlinedIcon = __ReactNativeSvgLoader(import('@src/assets/icons/heart_v2.svg'));
  ;

  const CommentIcon = __ReactNativeSvgLoader(import('@src/assets/icons/comment.svg'));
  ;
import useThemeColor from '@hooks/useThemeColor';
import { FormattedMessage } from 'react-intl';
import useReactToPostMutation from '@hooks/mutations/useReactToPostMutation';
import useUnreactToPostMutation from '@hooks/mutations/useUnreactToPostMutation';
import PropTypes from 'prop-types';
import { usePost } from '@ui/organisms/Post/postContext';

function PostToolbar({ onPressComment, sx = undefined }) {
  const primaryColor = useThemeColor('$primary.main');
  const post = usePost();

  const { mutate: react } = useReactToPostMutation(post.id);
  const { mutate: unreact } = useUnreactToPostMutation(post.id);
  const reactionType = post.currentUserReactionType;

  const handlePressLike = () => {
    if (reactionType === 'like') {
      unreact();
    } else {
      react({ type: 'like' });
    }
  };

  const handlePressHeart = () => {
    if (reactionType === 'heart') {
      unreact();
    } else {
      react({ type: 'heart' });
    }
  };

  return (
    <Flex sx={sx}>
      <Pressable onPress={handlePressLike} sx={{ flexDirection: 'row', alignItems: 'center', mr: '$3' }}>
        {reactionType === 'like' ? (
          <LikeIcon height={16} width={17} color={primaryColor} />
        ) : (
          <LikeOutlinedIcon height={16} width={17} color={primaryColor} />
        )}
        <Text
          variant={reactionType === 'like' ? 'subtitle' : undefined}
          sx={{ ml: '$2', color: reactionType === 'like' ? '$primary.main' : '$text.primary' }}
        >
          <FormattedMessage id="ui.Post.PostToolbar.like" />
        </Text>
      </Pressable>
      <Pressable onPress={handlePressHeart} sx={{ flexDirection: 'row', alignItems: 'center', mr: '$4' }}>
        {reactionType === 'heart' ? (
          <HeartIcon height={22} width={22} color={primaryColor} />
        ) : (
          <HeartOutlinedIcon height={22} width={22} color={primaryColor} />
        )}
        <Text
          variant={reactionType === 'heart' ? 'subtitle' : undefined}
          sx={{ ml: '$2', color: reactionType === 'heart' ? '$primary.main' : '$text.primary' }}
        >
          <FormattedMessage id="ui.Post.PostToolbar.heart" />
        </Text>
      </Pressable>
      <Pressable onPress={onPressComment} sx={{ flexDirection: 'row', alignItems: 'center' }}>
        <CommentIcon height={20} width={17} color={primaryColor} />
        <Text sx={{ ml: '$2' }}>
          <FormattedMessage id="ui.Post.PostToolbar.comment" />
        </Text>
      </Pressable>
    </Flex>
  );
}

PostToolbar.propTypes = {
  onPressComment: PropTypes.func.isRequired,
  sx: CustomPropTypes.style,
};

export default PostToolbar;

        